import { Circle, Polygon } from "ol/geom";
import { transform } from "ol/proj";

export default class GeofenceUtil {
    static formatCircleGeometry(circle: Circle) {
        const center = transform(circle.getCenter(), "EPSG:3857", "EPSG:4326");
        const radius = circle.getRadius();
        return `CIRCLE(${center[1]} ${center[0]},${radius})`;
    }

    static formatPolygonGeometry(polygon: Polygon) {
        const coordinates = polygon.getCoordinates()[0]; // Obtiene el anillo exterior
        const formattedCoords = coordinates.map(coord => {
            coord = transform(coord, "EPSG:3857", "EPSG:4326");
            return `${coord[1]} ${coord[0]}`
        }).join(', ');
        return `POLYGON((${formattedCoords}))`;
    }

    static parseCircleGeometry(circleString: string): Circle {
        // Extraer la información del centro y radio del string
        const regex = /CIRCLE\((-?\d+\.\d+) (-?\d+\.\d+),(\d+(\.\d+)?)\)/;
        const match = circleString.match(regex);
    
        if (!match) {
            throw new Error("String formato inválido");
        }
    
        const lat = parseFloat(match[1]);
        const lon = parseFloat(match[2]);
        const radius = parseFloat(match[3]);
    
        // Transformar las coordenadas al formato correcto y crear la geometría del círculo
        const center = transform([lon, lat], "EPSG:4326", "EPSG:3857");
        return new Circle(center, radius);
    }

    static parsePolygonGeometry(polygonString: string): Polygon {
        // Extraer las coordenadas del string
        const regex = /POLYGON\(\((.+)\)\)/;
        const match = polygonString.match(regex);
    
        if (!match) {
            throw new Error("String formato inválido");
        }
    
        const coordinates = match[1].split(', ').map(coordString => {
            const [lat, lon] = coordString.split(' ').map(Number);
            return transform([lon, lat], "EPSG:4326", "EPSG:3857");
        });
    
        // Crear la geometría del polígono
        return new Polygon([coordinates]);
    }
}